'use client'

import type { ComponentProps } from 'react'

import Link from 'next/link'
import { useState } from 'react'

export function HoverPrefetchLink({
	prefetch: _prefetch,
	onMouseEnter: _onMouseEnter,
	onTouchStart: _onTouchStart,
	...rest
}: ComponentProps<typeof Link>) {
	const [active, setActive] = useState(false)

	return (
		<Link
			{...rest}
			prefetch={active ? null : false}
			onMouseEnter={() => setActive(true)}
			onTouchStart={() => setActive(true)}
		/>
	)
}
